export default {
  fn: (value) =>
    value.every((agg) => agg.startsWith('agg_total')) || value.every((agg) => !agg.startsWith('agg_total')),
  message: 'You cannot use both Total and non-Total metrics together'
};
